export const getPriceForVariant = (variantPrice?: string, productPrice?: string) => {
	const price = Math.trunc(Number(variantPrice ?? productPrice) || 0);

	return price;
};
